module.exports = __webpack_public_path__ + "static/media/sls-background.9ffbc581.svg";